const statusPorSituacao = [
    {
        regra: 'UABS',
        situacoes: [
            {
                id: 0,
                status: [-1, 0, 1, 2, 3, 4, 5]
            },
            {
                id: 1,
                status: [-1, 0, 3]
            },
            {
                id: 2,
                status: [-1, 1, 4]
            },
            {
                id: 3,
                status: [-1, 2, 5]
            }
        ]
    }
]

export default statusPorSituacao
